var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7935 16.5003L18.0617 15.5004C18.8715 14.098 19.17 12.4581 18.9063 10.8602C18.6426 9.26238 17.833 7.80539 16.6154 6.73752C15.3979 5.66965 13.8478 5.05698 12.2292 5.0039C10.6106 4.95082 9.02361 5.4606 7.73873 6.4464C6.45385 7.4322 5.55053 8.83302 5.18268 10.4102C4.81484 11.9873 5.00522 13.6432 5.7214 15.0957C6.43758 16.5483 7.63525 17.7075 9.11033 18.376C10.5854 19.0445 12.2466 19.1808 13.811 18.7617L14.3286 20.6936C12.3174 21.2325 10.1815 21.0573 8.28487 20.198C6.38828 19.3386 4.84834 17.8483 3.92742 15.9808C3.0065 14.1133 2.7616 11.9843 3.23443 9.9565C3.70726 7.9287 4.86858 6.12758 6.52051 4.86003C8.17243 3.59248 10.2128 2.93693 12.2938 3.00507C14.3749 3.07321 16.368 3.86083 17.9335 5.23373C19.4989 6.60663 20.5399 8.47986 20.8791 10.5342C21.2183 12.5886 20.8346 14.6971 19.7935 16.5003Z",
    fill: "#FF4A01"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 12 12",
    to: "360 12 12",
    dur: "600ms",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingCircle);
export default __webpack_public_path__ + "static/media/loading-circle.6d703c6acf39eea34ab1b857354a0c76.svg";
export { ForwardRef as ReactComponent };